import { useSetAtom } from 'jotai'
import React from 'react'

import { surveyFilterKeyAtom } from '~/atoms'
import { useCurrentSurvey } from '~/hooks/useCurrentSurvey'

/**
 * ユーザーや現在のサーベイが更新されたらサーベイフィルターキーをatomに設定するカスタムフックです。
 */
export const useSetSurveyFilterKeyEffect = () => {
  const setSurveyFilterKey = useSetAtom(surveyFilterKeyAtom)
  const currentSurvey = useCurrentSurvey()

  React.useEffect(() => {
    const surveyId = currentSurvey.success ? currentSurvey.value.id : undefined
    setSurveyFilterKey(surveyId)
  }, [currentSurvey, setSurveyFilterKey])
}
